<template>
  <v-dialog v-model="visible" persistent max-width="560">
    <v-card>
      <v-card-title>
        {{ isEditing ? `Editar ${singularLabel}` : `Novo ${singularLabel}` }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-if="type === 'shoes'"
            v-model.number="form.value"
            :rules="shoeValueRules"
            label="Tamanho"
            type="number"
            min="1"
            step="1"
            outlined
            required
            autofocus
          />
          <v-text-field
            v-else
            v-model.trim="form.value"
            :rules="valueRules"
            label="Tamanho"
            outlined
            required
            autofocus
          />
          <v-text-field v-model.trim="form.text" label="Descrição" outlined />
          <v-text-field
            v-model.number="form.order"
            :rules="orderRules"
            label="Ordem"
            type="number"
            min="0"
            step="1"
            outlined
            required
          />
          <v-switch
            v-if="isEditing && size && size.active === false"
            v-model="form.active"
            :label="`Reativar ${singularLabel}`"
            color="indigo"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="close">Cancelar</v-btn>
        <v-btn color="indigo" dark :loading="loading" @click="save">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createSize, updateSize } from "../../../services/sizes";

export default {
  name: "SizeFormDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ["clothes", "shoes"].includes(value),
    },
    size: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      loading: false,
      form: {
        value: "",
        text: "",
        order: 1,
        active: true,
      },
      valueRules: [(value) => !!value || "Informe o tamanho."],
      shoeValueRules: [
        (value) => (value !== "" && value !== null) || "Informe o tamanho.",
        (value) =>
          !value ||
          (Number.isInteger(Number(value)) && Number(value) > 0) ||
          "Informe um número inteiro maior que zero.",
      ],
      orderRules: [
        (value) =>
          (value !== "" && value !== null && value !== undefined) ||
          "Informe a ordem.",
        (value) =>
          (Number.isInteger(Number(value)) && Number(value) >= 0) ||
          "A ordem deve ser um número inteiro maior ou igual a zero.",
      ],
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isEditing() {
      return !!(this.size && this.size.id);
    },
    singularLabel() {
      return this.type === "clothes" ? "tamanho de roupa" : "tamanho de sapato";
    },
  },
  watch: {
    value(value) {
      if (value) this.fillForm();
    },
  },
  methods: {
    fillForm() {
      this.form = {
        value: this.size ? this.size.value : "",
        text: this.size ? this.size.text || "" : "",
        order: this.size && this.size.order !== undefined ? this.size.order : 1,
        active: this.size ? this.size.active !== false : true,
      };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    close() {
      this.visible = false;
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      try {
        const data = {
          value:
            this.type === "shoes"
              ? Number(this.form.value)
              : String(this.form.value).trim(),
          text: this.form.text || "",
          order: Number(this.form.order),
          active: this.form.active,
        };

        if (this.isEditing) {
          if (this.size.active === false && this.form.active) {
            data.deleted_at = null;
          }
          await updateSize(this.type, this.size.id, data);
        } else {
          await createSize(this.type, data);
        }

        this.$emit("saved", {
          message: this.isEditing
            ? "Tamanho atualizado com sucesso."
            : "Tamanho criado com sucesso.",
        });
        this.close();
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
